import styled from 'styled-components';
import { Colors, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const imageSizePx = 56;

export const ItemContainer = styled.div`
  padding: ${Spacing.SINGLE} ${Spacing.SINGLE_HALF};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: ${Spacing.SINGLE};
  }
`;

export const ItemImageContainer = styled.div`
  background: ${Colors.GRAY_LITE_30};
  border-radius: 8px;
  margin-right: 8px;
  flex-shrink: 0;
  width: ${imageSizePx}px;
  height: ${imageSizePx}px;
  overflow: hidden;
`;

export const ItemRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ItemLeftColContainer = styled.div`
  display: flex;
  flex-grow: 1;
  cursor: pointer;
`;

export const ItemRightColContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
